// sections/DetailDatesSection.tsx

import { usePayableDetail } from '../../hooks/usePayableDetail';

const DetailDatesSection = () => {
  const { detail } = usePayableDetail();

  if (!detail) return null;

  /**
   * 🔥 Ahora las fechas ya vienen formateadas
   * desde backend en formato:
   *
   * dd/MM/yyyy
   *
   * por lo tanto ya NO usamos:
   * new Date().toLocaleDateString()
   */
  const safeDate = (date?: string) => {
    if (!date) return '-';
    return date;
  };

  return (
    <section
      className="
        rounded-xl
        border border-stroke
        bg-white
        p-6
        shadow-default
        dark:border-strokedark
        dark:bg-boxdark
      "
    >
      <h4 className="mb-5 text-base font-semibold text-black dark:text-white">
        Fechas Importantes
      </h4>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        {/* Fecha emisión */}
        <div
          className="
            rounded-lg
            border border-gray
            bg-gray-2
            p-4
            dark:border-strokedark
            dark:bg-boxdark-2
          "
        >
          <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
            Fecha emisión
          </p>

          <p className="font-semibold text-black dark:text-white">
            {safeDate(detail.issueDate)}
          </p>
        </div>

        {/* Fecha vencimiento */}
        <div
          className="
            rounded-lg
            border border-gray
            bg-gray-2
            p-4
            dark:border-strokedark
            dark:bg-boxdark-2
          "
        >
          <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
            Fecha vencimiento
          </p>

          <p className="font-semibold text-black dark:text-white">
            {safeDate(detail.dueDate)}
          </p>
        </div>

        {/* Días vencidos */}
        <div
          className={`
            rounded-lg
            border
            p-4
            ${
              detail.overdue
                ? `
                  border-danger/20
                  bg-danger/5
                  dark:border-danger/30
                  dark:bg-danger/10
                `
                : `
                  border-meta-3/20
                  bg-meta-3/5
                  dark:border-meta-3/30
                  dark:bg-meta-3/10
                `
            }
          `}
        >
          <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
            {detail.overdue ? 'Días vencidos' : 'Estado'}
          </p>

          <p
            className={`
              text-title-xsm
              font-bold
              ${detail.overdue ? 'text-danger' : 'text-meta-3'}
            `}
          >
            {detail.overdue ? `${detail.overdueDays} días` : 'Al día'}
          </p>
        </div>
      </div>
    </section>
  );
};

export default DetailDatesSection;
